export default "__VITE_ASSET__ugKx0XkU__"